<template>
  <div class="main-page">
    <div class="container">
      <app-bar
        title="Informasi"
        :previousLink="{ name: 'CheckoutPoli' }" />

      <div class="row pt-3">
        <div class="col-md-8">
          <div class="card mb-3 border-primary-soft">
            <div class="card-body">
              <p class="fw-700 fs-18 lh-28 mb-3">Ringkasan Pendaftaran {{ poliName }}</p>
              <p class="fw-400 fs-14 lh-22 color-neutral-600 mb-3">Periksa detail berikut sebelum melanjutkan ke pembayaran</p>

              <div class="box border rounded-3 p-3 mb-3">
                <div class="mb-2">
                  <div class="fw-700 fs-14 color-neutral-900">Tanggal</div>
                  <div class="fw-400 fs-14 color-neutral-700">{{ longDate }}</div>
                </div>
                <div class="mb-2">
                  <div class="fw-700 fs-14 color-neutral-900">Jam</div>
                  <div class="fw-400 fs-14 color-neutral-700">{{ poliSchedule }}</div>
                </div>
                <div class="mb-2">
                  <div class="fw-700 fs-14 color-neutral-900">Dokter</div>
                  <div class="fw-400 fs-14 color-neutral-700">{{ doctorName }}</div>
                </div>
                <div class="mb-2">
                  <div class="fw-700 fs-14 color-neutral-900">Kode Dokter</div>
                  <div class="fw-400 fs-14 color-neutral-700">{{ doctorCode }}</div>
                </div>
                <div>
                  <div class="fw-700 fs-14 color-neutral-900">Lokasi</div>
                  <div class="fw-400 fs-14 color-neutral-700">{{ clinicLocation }}</div>
                </div>
              </div>

              <div class="box border rounded-3 p-3 mb-3">
                <div class="fw-700 fs-16 color-neutral-900 mb-2">Data Pasien</div>
                <div class="d-flex justify-content-between">
                  <div class="fw-400 fs-14 color-neutral-700">Nama</div>
                  <div class="fw-700 fs-14 color-neutral-900">{{ patientName }}</div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <div class="fw-400 fs-14 color-neutral-700">NIK</div>
                  <div class="fw-700 fs-14 color-neutral-900">{{ patientNik }}</div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <div class="fw-400 fs-14 color-neutral-700">Tanggal Lahir</div>
                  <div class="fw-700 fs-14 color-neutral-900">{{ patientBirthDate }}</div>
                </div>
              </div>

              <div class="box border rounded-3 p-3 mb-3">
                <div class="fw-700 fs-16 color-neutral-900 mb-2">Rincian Biaya</div>
                <div class="d-flex justify-content-between" v-for="(item, idx) in feeItems" :key="idx">
                  <div class="fw-400 fs-14 color-neutral-700">{{ item.nama }}</div>
                  <div class="fw-700 fs-14 color-neutral-900">Rp {{ item.harga.toLocaleString('id-ID') }}</div>
                </div>
                <div class="d-flex justify-content-between mt-3 pt-2 border-top">
                  <div class="fw-600 fs-14 color-neutral-700">Total Tagihan</div>
                  <div class="fw-700 fs-18 color-neutral-900">Rp {{ totalAmount.toLocaleString('id-ID') }}</div>
                </div>
              </div>

              <!-- comment dulu mungkin nanti dipakai -->
              <!-- <div class="alert border rounded-3 p-3 text-center">
                <div class="fw-400 fs-12 color-neutral-700">
                  Dengan melanjutkan pembayaran/transaksi, Anda juga menyetujui
                  <router-link to="/privacy" class="text-orange">Syarat dan Ketentuan</router-link>
                  serta
                  <router-link to="/privacy" class="text-orange">Kebijakan Privasi</router-link>
                  Hai Parahita.
                </div>
              </div> -->

              <div class="py-3">
                <button @click="pay" class="btn btn-orange text-white w-100 pt-2 pb-2">
                  Lanjutkan ke Pembayaran
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppBar from '@/components/AppBar.vue'
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { showNotif } from '@/core/utility'
import { detail as orderDetail, getDetail as getOrderDetail } from '@/core/profile'

export default {
  components: { AppBar },
  setup () {
    const route = useRoute()
    const router = useRouter()
    const idOrder = computed(() => route.query.id_order)

    onMounted(async () => {
      if (idOrder.value) {
        await getOrderDetail({ kode: idOrder.value })
      }
    })

    const monthNames = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
    const longDate = computed(() => {
      const tanggal = orderDetail.value?.poli?.[0]?.tanggal
      if (!tanggal) return ''
      const d = new Date(tanggal)
      const hari = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'][d.getDay()]
      return `${hari}, ${d.getDate()} ${monthNames[d.getMonth()]} ${d.getFullYear()}`
    })

    const poliName = computed(() => orderDetail.value?.patients?.[0]?.pemeriksaan || '-')
    const poliSchedule = computed(() => orderDetail.value?.poli?.[0]?.jam || '-')
    const doctorName = computed(() => orderDetail.value?.poli?.[0]?.nama_dokter || '-')
    const doctorCode = computed(() => orderDetail.value?.poli?.[0]?.kode_dokter || '-')
    const clinicLocation = computed(() => orderDetail.value?.patients?.[0]?.cabang_periksa || '-')
    const patientName = computed(() => orderDetail.value?.patients?.[0]?.ap_nama || '-')
    const patientNik = computed(() => orderDetail.value?.patients?.[0]?.ap_noktp || '-')
    const patientBirthDate = computed(() => {
      const tgl = orderDetail.value?.patients?.[0]?.ap_tgl_lahir
      if (!tgl) return '-'
      const parts = tgl.split('-')
      if (parts.length !== 3) return tgl
      const [year, month, day] = parts
      const monthIndex = parseInt(month, 10) - 1
      const dayNum = parseInt(day, 10)
      if (Number.isNaN(monthIndex) || Number.isNaN(dayNum) || monthIndex < 0 || monthIndex > 11) return tgl
      return `${dayNum} ${monthNames[monthIndex]} ${year}`
    })

    const feeItems = computed(() => orderDetail.value?.services || [])
    const totalAmount = computed(() => orderDetail.value?.patients?.[0]?.nominal || 0)

    const pay = () => {
      const token = orderDetail.value?.patients?.[0]?.token

      if (!token) {
        showNotif({ status: 'error', message: 'Data token tidak ditemukan' })
        return
      }

      window.getSnap().then(snap => {
        snap.pay(token, {
          onSuccess: () => {
            router.push({ name: 'ProfilOrderDetail', params: { id_order: idOrder.value } })
          }
        })
      })
    }

    return {
      // route
      idOrder,
      // computed display
      longDate,
      poliName,
      poliSchedule,
      doctorName,
      doctorCode,
      clinicLocation,
      patientName,
      patientNik,
      patientBirthDate,
      feeItems,
      totalAmount,
      pay
    }
  }
}
</script>

<style lang="scss" scoped>
.border-primary-soft {
  border: 1px solid #BFE3EB;
}

.text-orange {
  color: #FF8A00;
}
</style>
